/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_Natural_VoicesInputs */

const en_why_listening_compare_natural_voices = /** @type {(inputs: Why_Listening_Compare_Natural_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natural, human-sounding voices`)
};

const es_why_listening_compare_natural_voices = /** @type {(inputs: Why_Listening_Compare_Natural_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voces naturales, como de persona`)
};

/**
* | output |
* | --- |
* | "Natural, human-sounding voices" |
*
* @param {Why_Listening_Compare_Natural_VoicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_natural_voices = /** @type {((inputs?: Why_Listening_Compare_Natural_VoicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_Natural_VoicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_natural_voices(inputs)
	return en_why_listening_compare_natural_voices(inputs)
});